import ApiBase from './base';

export default class ClaimService extends ApiBase {
  async exportClaims(body: unknown) {
    const { data } = await this.client.post(`v1/claims/export-claims`, body);

    return data;
  }

  async getStoreCreditUsagesByOrder(orderId: string) {
    const { data } = await this.client.get(`v1/claims/credits/usages/${orderId}`);

    return data;
  }
}
